import {
    RejectionReasonControllerApi,
    RejectionStatsConfigBean,
    RejectionStatsConfigUpdateRequest,
    RejectionStatsRequestBean,
    RejectionStatResponseBean,
    RejectionConfigType,
    FeatureFlagMap,
} from 'src/api/api';
import { BaseApi, configuration } from 'src/api/BaseApi';
import { processError } from 'src/api/customFetch';

class RejectionReasonApi extends BaseApi {
    api: RejectionReasonControllerApi;

    constructor() {
        super();
        this.api = new RejectionReasonControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    async getFeatureFlag(name: string): Promise<FeatureFlagMap> {
        try {
            return await this.api.getFeatureFlag(name);
        } catch (err) {
            return processError(err);
        }
    }

    async getConfig(type: RejectionConfigType): Promise<RejectionStatsConfigBean> {
        try {
            return await this.api.getConfig(type);
        } catch (err) {
            return processError(err);
        }
    }

    async updateConfig(type: RejectionConfigType, body: RejectionStatsConfigUpdateRequest): Promise<RejectionStatsConfigBean> {
        try {
            return await this.api.updateConfig(type, body);
        } catch (err) {
            return processError(err);
        }
    }

    async startCapture(type: RejectionConfigType): Promise<RejectionStatsConfigBean> {
        try {
            return await this.api.startCapture(type);
        } catch (err) {
            return processError(err);
        }
    }

    async stopCapture(type: RejectionConfigType): Promise<RejectionStatsConfigBean> {
        try {
            return await this.api.stopCapture(type);
        } catch (err) {
            return processError(err);
        }
    }

    async getPublisherRejectionStats(body: RejectionStatsRequestBean): Promise<RejectionStatResponseBean[]> {
        try {
            return await this.api.getPublisherRejectionStats(body);
        } catch (err) {
            return processError(err);
        }
    }

    async getDspRejectionStats(body: RejectionStatsRequestBean): Promise<RejectionStatResponseBean[]> {
        try {
            return await this.api.getDspRejectionStats(body);
        } catch (err) {
            return processError(err);
        }
    }
}

const rejectionReasonApi = new RejectionReasonApi();
export default rejectionReasonApi;